export default __webpack_public_path__ + "static/media/woman-mobile.b136e009.webp";